export const GAS_MODES = {
  STANDARD: "STANDARD",
  FAST: "FAST",
  INSTANT: "INSTANT",
};
